

// Material Dashboard 2 React helper functions
import hexToRgb from "../../../assets/theme-dark/functions/hexToRgb";

function rgba(color, opacity) {
  return `rgba(${hexToRgb(color)}, ${opacity})`;
}

export default rgba;
